"use client";

import { c as _c } from "react/compiler-runtime";
import { Tab as AriaTab, TabList as AriaTabList, TabListProps as AriaTabListProps, TabPanel as AriaTabPanel, TabPanelProps as AriaTabPanelProps, TabProps as AriaTabProps, Tabs as AriaTabs, TabsProps as AriaTabsProps, composeRenderProps } from "react-aria-components";
import { cn } from "@/utils/cn";
function Tabs(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = composeRenderProps(className, _temp);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <AriaTabs className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp(className_0) {
  return cn("group flex flex-col gap-2", "data-[orientation=vertical]:flex-row", className_0);
}
const TabList = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = composeRenderProps(className, _temp2);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <AriaTabList className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
const Tab = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = composeRenderProps(className, _temp3);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <AriaTab className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
const TabPanel = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = composeRenderProps(className, _temp4);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <AriaTabPanel className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export { Tab, TabList, TabPanel, Tabs };
function _temp2(className_0) {
  return cn("inline-flex items-center justify-start gap-6 w-full border-b border-border", "data-[orientation=vertical]:flex-col data-[orientation=vertical]:items-start data-[orientation=vertical]:gap-2", "data-[orientation=vertical]:border-b-0 data-[orientation=vertical]:border-r data-[orientation=vertical]:h-auto", className_0);
}
function _temp3(className_0) {
  return cn("relative inline-flex items-center justify-center whitespace-nowrap px-1 py-4 text-sm font-medium outline-none transition-all cursor-pointer focus-subtle", "data-[disabled]:pointer-events-none data-[disabled]:opacity-50", "data-[selected]:text-foreground", "hover:text-foreground/80 hover:after:opacity-50", "after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-foreground after:opacity-0 after:transition-opacity", "data-[selected]:after:opacity-100", "group-data-[orientation=vertical]:w-full group-data-[orientation=vertical]:justify-start", "group-data-[orientation=vertical]:px-4 group-data-[orientation=vertical]:py-2", "group-data-[orientation=vertical]:after:left-auto group-data-[orientation=vertical]:after:right-0", "group-data-[orientation=vertical]:after:top-0 group-data-[orientation=vertical]:after:h-full", "group-data-[orientation=vertical]:after:w-0.5 group-data-[orientation=vertical]:after:opacity-0", "group-data-[orientation=vertical]:data-[selected]:after:opacity-100", className_0);
}
function _temp4(className_0) {
  return cn("py-8 px-4 ring-offset-background focus-visible:outline-none focus-subtle", className_0);
}